<img [ngClass]="{'progress-circle': plateforme.isDesktop(), 'progress-circle-mobile': plateforme.isMobile()}"
     src="./assets/svg/circle_progress_{{pourcentage}}.svg"
     alt="Cercle de progression">
